import { Grid } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";
import { isElementInArray } from "../../../../Utils/arrays";
import { nameOf } from "../../../../Utils/nameOf";
import { BidPack } from "../../BidPack";
import { RHFDatePicker } from "../../../../Forms/RHFDatePicker";
import { TransportTypes } from "../../TransportTypes";
import { RhfEquipmentMultiSelect } from "../RhfEquipmentMultiSelect";

export const BidPackDetails = ({ disabledFields }: MdmFormProps) => {
  const { control } = useFormContext<BidPack>();

  const { TransportType } = useWatch({ control });

  return (
    <BorderedFormGrid>
      <Grid item xs={12}>
        <RHFDatePicker control={control} name="StartDate" label="Start Date" required />
      </Grid>
      <Grid item xs={12}>
        <RHFDatePicker control={control} name="EndDate" label="End Date" />
      </Grid>
      <Grid item xs={12}>
        <RhfEquipmentMultiSelect
          control={control}
          name="EquipmentIds"
          disabled={
            TransportType === TransportTypes.LTL ||
            isElementInArray(disabledFields, nameOf<BidPack>("EquipmentIds"))
          }
        />
      </Grid>
    </BorderedFormGrid>
  );
};
